import { ScheduledConsultationTypeDTO, type HospitalDTO, type UserDTO } from '@/generated'
import { translateMedicalFieldsDTO } from '@/util/translations'
import { useI18n } from 'vue-i18n'

const CONFERENCE_RECIPIENT_LIMIT = 10
const PATIENT_PRESENTATION_RECIPIENT_LIMIT = 10
const WARD_ROUND_RECIPIENT_LIMIT = 10

export const useConsultationPhysician = () => {
  const { t } = useI18n()

  function formatPhysicianFullname(
    user: Pick<UserDTO, 'firstName' | 'lastName' | 'title'>
  ): string {
    return `${user.title ? user.title + ' ' : ''}${user.firstName ? user.firstName + ' ' : ''}${user.lastName}`.trim()
  }

  function formatPhysicianDetails({
    medicalFields = [],
    hospitals = []
  }: {
    medicalFields?: string[]
    hospitals?: HospitalDTO[]
  }): string {
    const hospitalNames = hospitals.map((h) => h.name)
    const medicalFieldsNames =
      medicalFields.map((field) => translateMedicalFieldsDTO(field, t)) ?? []

    const details = [...medicalFieldsNames, ...hospitalNames]

    if (details.length === 0) {
      return ''
    }

    return `(${details.join(', ')})`
  }

  function getRecipientLimitByConsultationType(
    consultationType: ScheduledConsultationTypeDTO
  ): number {
    switch (consultationType) {
      case ScheduledConsultationTypeDTO.CONFERENCE:
        return CONFERENCE_RECIPIENT_LIMIT
      case ScheduledConsultationTypeDTO.PATIENT_PRESENTATION:
        return PATIENT_PRESENTATION_RECIPIENT_LIMIT
      case ScheduledConsultationTypeDTO.PATIENT_VISIT:
      default:
        return WARD_ROUND_RECIPIENT_LIMIT
    }
  }

  return {
    formatPhysicianFullname,
    formatPhysicianDetails,
    getRecipientLimitByConsultationType
  }
}
